import PropTypes from "prop-types";
import styles from "./AddressItem.module.css";
import Button from "Shared/Button";
import AddressInfo from "components/AddressInfo";
import check from "assets/check.svg";
import { useTranslation } from "react-i18next";

/**
 * View component, An address item that can be selected and deselected.
 */
export function AddressItem({ addressInfo, isSelected, onSelect }) {
  const {t} = useTranslation();

  const buttonContent = isSelected ? (
    <img src={check} alt="Selected" />
  ) : (
    t("Select")
  );

const buttonClassName = isSelected ? "selectedAddressBtn" : "selectAddressBtn";
  return (
      <div className={styles.container}>
          <div className={styles.button}> 
              <Button
        text={buttonContent}
        className={buttonClassName}
        onClick={onSelect}
      />
          </div>
      
      <AddressInfo addressInfo={addressInfo} />
    </div>
  );
}

AddressItem.propTypes = {
  addressInfo: PropTypes.shape({
    country: PropTypes.string,
    address1: PropTypes.string,
    address2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
  }),
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func,
};
